import * as React from 'react';
import { HeaderLayout } from '../../components/HeaderLayout';
import { RegionsContainer } from '../Regions';
import { SearchInputContainer } from '../SearchInput';
import { SortingContainer } from '../Sorting';

export function HeaderContainer(): React.JSX.Element {
  return (
    <HeaderLayout
      regions={<RegionsContainer />}
      searchInput={<SearchInputContainer />}
      sorting={<SortingContainer />}
    />
  );
}
